// extracted by extract-css-chunks-webpack-plugin
module.exports = {"control-container":"control-container--[Frida]_3fDC"};